import { render } from "./points.vue?vue&type=template&id=7560a980"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"

import "./points.vue?vue&type=style&index=0&id=7560a980&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__